import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Pains } from './components/Pains';
import { Audience } from './components/Audience';
import { Overview } from './components/Overview';
import { Tomos } from './components/Tomos';
import { Extras } from './components/Extras';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { PremiumUpsell } from './components/PremiumUpsell';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
import { PlanProvider } from './contexts/PlanContext';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <PlanProvider data-id="element-0" data-mp="23vuo6c6s2uum">
    <div className="min-h-screen w-full bg-night font-sans text-bone" data-id="element-1" data-mp="23w4c7u89irxo">
      <OfferBar data-id="element-2" data-mp="3ik7g4ghnibqn" />
      <Hero data-id="element-3" data-mp="3ikqzm1my986s" />
      <main data-id="element-4" data-mp="3iiwfuqnezm4a">
        <Testimonials data-id="element-5" data-mp="3ijfx0558q6h9" />
        <Pains data-id="element-6" data-mp="3ihv0wb3a2fha" />
        <Audience data-id="element-7" data-mp="3mlj8gtrwtb2j" />
        <Overview data-id="element-8" data-mp="3ml12v6jcxkhy" />
        <Tomos data-id="element-9" data-mp="3mkho1yp07c85" />
        <Extras data-id="element-10" data-mp="3mjzuj9tq7c3x" />
        <Comparison data-id="element-11" data-mp="3mjga9mglsbmq" />
        <Pricing data-id="element-12" data-mp="3rc9ca2kot5v4" />
        <PremiumUpsell data-id="element-13" data-mp="3rbrbqtqzs5he" />
        <Guarantee data-id="element-14" data-mp="3rdkisa5iorpx" />
        <Faq data-id="element-15" data-mp="3rd19tixuhdo1" />
        <FinalOffer data-id="element-16" data-mp="3reltuemj9e7n" />
      </main>
      <Footer data-id="element-17" data-mp="6hovayao7c0" />
      <PurchasePopup data-id="element-18" data-mp="4wv3njt0sf7" />
    </div>
    </PlanProvider>;
}